<template>
    <div v-if="isPortrait" class="row" style="height: 100%;">

        <q-card class="my-card q-my-auto q-mx-xl q-px-xl q-py-xl" dark>
            <q-card-section class="text-center">
                <q-icon name="screen_rotation" color="white" size="60px"></q-icon>
            </q-card-section>
            <q-card-section class="text-center">
                Tournez votre appareil en orientation paysage pour afficher la vue employés.
            </q-card-section>
        </q-card>



    </div>
    <div class="c-dashboard-monthly"
        :class="{'-is-mobile' : isMobile}"
        :data-component-name="$options.name"
        v-else
    >
        <div class="c-dashboard__loading" v-if="$apollo.queries.paginatedResources.loading || !showProjects">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div class="c-monthly-row -bg">
            <div class="c-monthly-cell -gap"></div>
            <div class="c-monthly-cell"
                v-bind:key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
            </div>
            <div class="c-monthly-cell -gap"></div>
        </div>

		<!-- FOOTER -->
        <MonthViewFooter
            :currentDate="currentDate"
            :monthrange="monthrange"
            :monthdays="monthdays"
            :isMobile="isMobile"
            @set-current-date="$emit('set-current-date', $event)"
            @set-more-filters="moreFilters=$event"
        />

        <div class="c-monthly-row">
            <div class="c-monthly-cell -gap" style="height: 30px;"><!-- NEEDED FOR 20PX GAP --></div>
            <div class="c-monthly-cell -name -order-by" style="height: 30px;">
                <div class="c-project__name u-text-truncate">
                    <OrderBy
                        :options="[
                            { value: 'name', label: 'Nom de la ressource' },
                            { value: 'updated_at', label: 'Date de mise à jour' },
                            { value: 'created_at', label: 'Date de création' },
                            { value: 'custom_order', label: 'Tri personnalisé' }
                        ]"
                        @update:orderBy="orderBy=$event.field;
                            orderSort=$event.sort;"
                        scope="resourceView"
                    />
                </div>
            </div>
        </div>

        <div class="c-monthly-row__wrap" v-if="showProjects==true">
            <div
                v-bind:key="resource.id"
                v-for="resource in paginatedResourcesList"
                :id="'resource'+resource.id"
            >
                <!-- <div
                    class="c-monthly-row"
                    v-if="resource.assignmentsSummary.datedAssignments.length>0 || resourcesFilter=='All'"
                > -->
                <div
                    class="c-monthly-row"
                >
                    <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                    <div class="c-monthly-cell"
                        v-bind:key="index"
                        v-for="(monthday, index) in monthdays"
                        :class="[
                            {
                                '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                                '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6,
                            },
                            'week-'+resource.id+'-'+monthday.week
                        ]"
                        @mouseenter="addClass('.week-'+resource.id+'-'+monthday.week)"
                        @mouseleave="removeClass('.week-'+resource.id+'-'+monthday.week)"
                    >
                        <!-- <div class="c-project" v-if="resource.datedSummaries[monthday.dateStr]"
                            :class="resource.datedSummaries[monthday.dateStr].state"
                            @click="$emit('jump-to-project-week', {currentDate: monthday.dateStr, resourceID: resource.id} )"
                        > -->
                        <div class="c-project" v-if="resource.datedSummaries[monthday.dateStr]"
                            :class="resource.datedSummaries[monthday.dateStr].state"
                        >
                            <div v-if="resource.datedSummaries[monthday.dateStr].state=='-summary-cell -draft'">
                                <UserProfileInfo forceType="Resource" iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="resource" :customContent="resource.datedSummaries[monthday.dateStr].totalHours" class="fit-fill-center" :size="'16px'" />
                            </div>
                            <div v-else-if="resource.datedSummaries[monthday.dateStr].state=='-warning-absence' || resource.datedSummaries[monthday.dateStr].state=='-alert-absence'" class="fit-fill-center">
                                <span class="o-absence-type-dot__wrapper" v-if="resource.datedSummaries[monthday.dateStr].unavailabilities[0] && resource.datedSummaries[monthday.dateStr].unavailabilities[0].type && resource.datedSummaries[monthday.dateStr].unavailabilities[0].type.color && resource.datedSummaries[monthday.dateStr].unavailabilities[0].type.color!=''">
                                    <span class="o-absence-type-dot" :style="'background-color: '+ resource.datedSummaries[monthday.dateStr].unavailabilities[0].type.color">
                                    </span>
                                </span>
                                <UserProfileInfo forceType="Resource" iconname="event_busy" iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="resource" class="fit-fill-center" :size="'16px'" />
                            </div>
                            <div v-else class="-summary-cell">
                                <!-- {{ resource.datedSummaries[monthday.dateStr].totalHours }} -->
                                <span>
                                    <span>
                                        <UserProfileInfo forceType="Resource" iconcolor="white" defaultTab="schedule" :scheduleScrollTo="monthday.dateStr" :currentDate="monthday.dateStr" :userProfile="resource" :customContent="resource.datedSummaries[monthday.dateStr].totalHours" class="fit-fill-center" :size="'16px'" />
                                    </span>
                                </span>
                                <!-- {{ resource.datedSummaries[monthday.dateStr].ids }} -->

                                <div class="-progression" v-if="resource.datedSummaries[monthday.dateStr].state!='-completed'" :style="'width:'+resource.datedSummaries[monthday.dateStr].progression">
                                </div>
                                <!-- <div class="notifications-state__wrapper" > -->
                                    <div v-if="resource.datedSummaries[monthday.dateStr].nightShift">
                                        <q-icon name="brightness_2" class="-nightShift" />
                                        <q-tooltip>
                                            <div v-html="'Quart de travail de nuit'">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else class="q-mr-auto"></div>
                                    <div class="-auto-notifs" v-if="resource.datedSummaries[monthday.dateStr].assignments_summary_sent_at">
                                        <q-icon name="mail" />
                                        <q-tooltip>
                                            <div
                                                v-html="'Notification automatique (horaire) envoyée le ' + resource.datedSummaries[monthday.dateStr].assignments_summary_sent_at">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else-if="resource.datedSummaries[monthday.dateStr].notification_sent">
                                        <q-icon name="call_made" class="-manual-notifs" style="opacity: 0.6"/>
                                        <q-tooltip>
                                            <div v-html="'Notification manuelle envoyée le ' + resource.datedSummaries[monthday.dateStr].notification_sent"></div>
                                        </q-tooltip>
                                    </div>
                                    <div v-else-if="resource.datedSummaries[monthday.dateStr].notification_pending">
                                        <q-icon name="notifications" class="-manual-notifs" />
                                        <q-tooltip>
                                            <div v-html="'Notification manuelle à envoyer'">
                                            </div>
                                        </q-tooltip>
                                    </div>
                                <!-- </div> -->
                            </div>
                            <q-tooltip v-if="resource.datedSummaries[monthday.dateStr].tooltipStr">
                                <div v-html="resource.datedSummaries[monthday.dateStr].tooltipStr"></div>
                            </q-tooltip>
                            <!-- <pre>{{ resource.datedSummaries[monthday.dateStr] }}</pre> -->
                        </div>
                    </div>

                    <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                    <div class="c-monthly-cell -name">
                        <div class="c-project__category" :style="'border-color:' + resource.type.color"
                            v-if="resource.type"></div>
                        <div class="c-project__category" v-else style="border-right:none;"></div>
                        <div class="c-project__name u-text-truncate q-pl-md" v-if="!isMobile">
                            <div class="u-text-truncate">
                                {{ resource.name }}
                            </div>
                            <span>
                                <UserProfileInfo forceType="Resource" :currentDate="monthrange.str.from" :userProfile="resource" class="q-mr-xs" :size="'16px'" defaultTab="schedule" />
                            </span>
                        </div>
                        <div class="c-project__name u-text-truncate q-pl-md" v-else>
                            <!-- <div class="u-text-truncate">
                                {{ resource.name }}
                            </div> -->
                            <!-- <span> -->
                                <UserProfileInfo forceType="Resource" :currentDate="monthrange.str.from" :userProfile="resource" :customContent="resource.name" class="q-mr-xs u-text-truncate" :size="'16px'" defaultTab="schedule" />
                            <!-- </span> -->
                        </div>
                    </div>
                </div>

                <!-- <div class="c-dashboard-project" v-if="showProjectDetails==resource.id">
                    <ProjectForm class="c-dashboard-project__inner"
                        @refetch-resources="refreshProject($event)"
                        @cancel="toggleProjectDetails(resource.id)"
                        v-bind:project="resource"
                        v-bind:weekrange="daterange"
                        :projectDetailsVisible="parseInt(projectDetailsVisible)"
                    />
                </div> -->
            </div>
            <div
                class="c-monthly-row"
                v-if="paginatedResources && paginatedResources.paginatorInfo.hasMorePages && !$apollo.queries.paginatedResources.loading"
                ref="loadMoreProjects"
            >
                <div style="color: white"></div>
            </div>
        </div>
        <div class="c-monthly-row__wrap" v-else>
            <div class="-spacer"></div>
        </div>

		<!-- <div class="c-monthly-row -header" v-if="!this.isMobile">
            <div class="c-monthly-cell -gap"></div>

            <div class="c-monthly-cell"
                v-bind:key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
                <div>
                    <div v-if="monthday.summary">{{ monthday.summary.count }}</div>
                    <div v-if="monthday.summary">{{ paginatedResourcesList.length - monthday.summary.unavailabilities }}</div>
                </div>
            </div>
            <div class="c-monthly-cell -gap"></div>
        </div> -->
<!-- {{monthrange}} -->
    </div>
</template>

<script>
    // import ProjectForm from '@/components/forms/ProjectForm'
    import MonthViewFooter from "@/components/nav/MonthViewFooter";
    import {getDatesBetween, getMonthLimits, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import { PAGINATEDRESOURCES } from '@/graphql/resource/queries'
    import moment from 'moment';


    export default {
        name: 'ResourcesView',
        components: {
            MonthViewFooter,
            // ProjectForm
        },
        props: {
            projectIDs: {
                type: [Number, Array],
                default(){
                    return new Array()
                }
            },
            currentDate: String,
            projectsFilter: {
                type: String,
                default: 'All'
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showProjects: false,
                showProjectDetails: 0,
                projectDetailsVisible: 0,
                totalCount: {},
                monthdays: [],
                assignmentIDs: [],
                showAssignmentsDetails: false,
                pageSize: 25,
                loading: false,
                currentPage: 1,
                moreFilters: null,
                orderBy: 'name',
                orderSort: 'ASC',
                isPortrait: false,
            }
        },
        mounted() {
            this.$eventBus.$emit('clear-more-filters');
            this.monthdays=this.setMonthDays();

            this.$eventBus.$on('refresh-user-assignments', function(e){
                this.refreshUserAssignments(e.resourceID);
            }.bind(this))

            // if (document.getElementById('app')) {
            //     this.isPortrait = document.getElementById('app').offsetWidth < 440
            // }

            let passiveSupported = false;
            try {
                const options = {
                    get passive() { 
                        passiveSupported = true;
                        return false;
                    }
                };

                window.addEventListener("test", null, options);
                window.removeEventListener("test", null, options);
            } catch(err) {
                passiveSupported = false;
            }
            document.addEventListener('scroll', this.onScroll, passiveSupported ? { passive: true } : false);
            window.addEventListener("resize", this.detectIfPortrait);
            this.detectIfPortrait();

        },
        beforeDestroy(){
            document.removeEventListener('scroll', this.onScroll);
            this.$eventBus.$off('refresh-user-assignments');
            window.removeEventListener("resize", this.detectIfPortrait);
        },
        computed: {
            paginatedResourcesList(){
                if(!this.paginatedResources || !this.paginatedResources.data) return [];
                let paginatedResourcesList = JSON.parse(JSON.stringify(this.paginatedResources.data));
                this.setMonthDays(true);
                let summaries={};
                let daySummary = {};
                
                paginatedResourcesList.forEach(function(resource){
                    let draftAssignmentIDs = [];
                    resource.datedSummaries={}
                    let userDaySummarySetted = {};

                    resource.assignments.forEach(function(assignment){
                        let date = assignment.date
                        if (!userDaySummarySetted[date]) {
                            daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                            userDaySummarySetted[date] = true;
                            if (daySummary[date]) daySummary[date].summary.count += 1;
                        }
                        if (!resource.datedSummaries[date]) resource.datedSummaries[date] = { ids: [], assignments: [], draftAssignments: [], unavailabilities: [], notification_pending: false, notification_sent: false, assignments_summary_sent_at: false, progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                        // if(!resource.datedSummaries[date].assignments) resource.datedSummaries[date].assignments=[]
                        if (!resource.datedSummaries[date].notification_sent) resource.datedSummaries[date].notification_sent = assignment.notification_sent_at
                        if (!resource.datedSummaries[date].notification_pending) resource.datedSummaries[date].notification_pending = assignment.notification_pending;
                        if (!resource.datedSummaries[date].assignments_summary_sent_at) resource.datedSummaries[date].assignments_summary_sent_at = assignment.assignments_summary_sent_at;
                        resource.datedSummaries[date].assignments.push(assignment);
                        draftAssignmentIDs.push(assignment.draft_resource_assignment_id)
                    }.bind(this))

                    resource.draftAssignments.forEach(function(assignment){
                        if(!draftAssignmentIDs.includes(assignment.id)) {
                            let date=assignment.date
                            if(!resource.datedSummaries[date]) resource.datedSummaries[date]={ids: [], assignments: [], draftAssignments: [], unavailabilities: [], progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                            resource.datedSummaries[date].draftAssignments.push(assignment);

                            if (!userDaySummarySetted[date]) {
                                daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                                userDaySummarySetted[date] = true;
                                if (daySummary[date]) daySummary[date].summary.count += 1;
                            }

                        }
                    }.bind(this))

                    resource.unavailabilities.forEach(function(absence){
                        let date=absence.date
                        if(!resource.datedSummaries[date]) resource.datedSummaries[date]={ids: [], assignments: [], draftAssignments: [], unavailabilities: [], progression: 0, totalHours: 0, draft: 0, pending: 0, accepted: 0, denied: 0, state: '-completed', tooltipStr: '', nightShift: false};
                        resource.datedSummaries[date].unavailabilities.push(absence);

                        daySummary[date] = this.monthdays.find(d => d.dateStr === date);
                        if (daySummary[date]) daySummary[date].summary.unavailabilities += 1;

                    }.bind(this))

                    resource.datedSummaries = this.getSummaryState(resource.datedSummaries, resource.name);
                }.bind(this))
                this.monthdays.forEach(function(monthday, key){
                    if(summaries[monthday.dateStr]){
                        // this.monthdays[key].summary=Object.assign({}, summaries[monthday.dateStr]);
                        this.monthdays[key].summary=this.getSummaryState(summaries[monthday.dateStr]);
                    }
                }.bind(this))

                return paginatedResourcesList;
            },
            monthrange(){
                return getMonthLimits(this.currentDate)
            },
            daterange() {
                let length = 41
                let offset = -5
                if (this.isMobile) {
                    length = 16
                    offset = -5
                    if (this.isPortrait) {
                        offset = -4
                        length = 9
                    }
                }
                return getMonthLimits(this.currentDate, length, offset)
            },
            monthWeeks(){
                let monthWeeks=[];
                let starting=true;
                let i=-1;
                this.monthdays.forEach(function(monthday){
                    if(monthday.date.getDay()==0 || starting){
                        i++;
                        monthWeeks[i]=[];
                    }
                    monthWeeks[i].push(monthday);
                    starting=false;
                })

                return monthWeeks;
            }
        },
        methods: {
            detectIfPortrait() {
                if (document.getElementById('app')) {
                    this.isPortrait = document.getElementById('app').offsetWidth < 440
                    return;
                }
            },

            refreshUserAssignments(resourceID){
                if(!resourceID) return;
                let variables={};
                if(this.daterange) variables.dateRange=this.daterange.str;
                if(this.daterange) variables.shiftsDateRange=this.daterange.str;
                if(this.projectIDs.length>0) variables.ids=this.projectIDs;
                variables.ids=[resourceID];
                variables.first=1;

                this.$apollo.query({
                    query: PAGINATEDRESOURCES,
                    fetchPolicy: 'network-only',
                    variables: {
                        ...variables
                    },
                }).then(() => {
                    //quedalle
                })
            },
            addClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.add('hover')
                })
            },
            removeClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.remove('hover')
                })
            },
            getSummaryState(datedSummaries, resourceName){
                // let state='', tooltips=[];
                // summary.tooltipStr='';
                Object.keys(datedSummaries).forEach(function(date){
                    let tooltips=[];
                    datedSummaries[date].assignments.forEach(function(assignment){
                        let start=moment(assignment.date+'T'+assignment.start_time),
                        end=moment(assignment.date+'T'+assignment.end_time),
                        isAlert=false;
                        datedSummaries[date].ids.push(assignment.id);

                        if(end<=start){
                            end=end.add(1, 'days');
                            datedSummaries[date].nightShift=true;
                        }
                        let hours=moment.duration(end.diff(start)).asHours()


                        if(assignment.deniedByUser){
                            datedSummaries[date].state='-alert'
                            tooltips.push("L'affectation "+assignment.id+" a été refusée par "+assignment.accepted_by.name)
                            isAlert=true;
                        }

                        if(assignment.maybeByUser){
                            datedSummaries[date].state='-published'
                            // tooltips.push("L'affectation "+assignment.id+" a été refusée par "+assignment.accepted_by.name)
                            tooltips.push(assignment.accepted_by.name+" a répondu peut-être à l'affectation "+assignment.id)
                            isAlert=true;
                        }


                        if(!isAlert){
                            datedSummaries[date].totalHours=Math.round((parseInt(datedSummaries[date].totalHours)+parseInt(hours))*10)/10;

                            if(!assignment.accepted_by && datedSummaries[date].state!='-alert'){
                                datedSummaries[date].state="-completed"
                            }

                        }

                        if (!assignment.draftResourceAssignment) {
                            datedSummaries[date].state = datedSummaries[date].state + ' -hasdraft'
                            tooltips.push("Cette journée contient des informations non publiées pour le projet «" + assignment.project.name + "» / quart de travail «" + assignment.projectShift.name + "»")
                        }

                        if (assignment.hasAssignmentError) {
                            datedSummaries[date].state = datedSummaries[date].state + ' -alert'
                            tooltips.push(resourceName + " est affecté sur plus d'un projet pour cette journée")
                            // isAlert = true;
                        }

                    })

                    datedSummaries[date].draftAssignments.forEach(function(assignment){
                        let start=moment(assignment.date+'T'+assignment.start_time),
                            end=moment(assignment.date+'T'+assignment.end_time);
                        // isAlert=false;
                        datedSummaries[date].ids.push(assignment.id);

                        if(end<=start){
                            end=end.add(1, 'days');
                            datedSummaries[date].nightShift=true;
                        }
                        let hours=moment.duration(end.diff(start)).asHours()

                        if(datedSummaries[date].assignments.length){
                            datedSummaries[date].state=datedSummaries[date].state+' -hasdraft';
                        }
                        tooltips.push("Cette journée contient des informations non publiées pour le projet «"+assignment.project.name + "» / quart de travail «"+assignment.projectShift.name+"»")
                        if(!datedSummaries[date].assignments.length) datedSummaries[date].state='-draft';


                        datedSummaries[date].totalHours=Math.round((parseInt(datedSummaries[date].totalHours)+parseInt(hours))*10)/10;

                    })

                    if(datedSummaries[date].unavailabilities && datedSummaries[date].unavailabilities.length>0){
                        if(datedSummaries[date].assignments && datedSummaries[date].assignments.length>0){
                            datedSummaries[date].state='-alert-absence';
                            tooltips.push(resourceName+" est affecté(e) "+datedSummaries[date].totalHours+" heures lors d'une journée d'indisponibilité : "+ datedSummaries[date].unavailabilities[0].type.name)
                        }else{
                            datedSummaries[date].state='-warning-absence';
                            tooltips.push(resourceName+" est indisponible cette journée : " + datedSummaries[date].unavailabilities[0].type.name)
                        }
                        datedSummaries[date].totalHours=-1
                    }
                    
                    if(tooltips.length>0){
                        datedSummaries[date].tooltipStr='• '+tooltips.join('<br>• ');
                    }

                }.bind(this))
                return datedSummaries;
            },
            setMonthDays(setIt = false){
                let monthdays=[]
                let dateRange=getDatesBetween(this.daterange.obj.from, this.daterange.obj.to)
                let starting=true;
                let week=-1;
                dateRange.forEach(function(date){
                    if(date.getDay()==this.$generalSettings.settings.firstDayOfWeek || starting){
                        week++;
                        starting=false;
                    }
                    monthdays.push({
                        totalOccupation: 0,
                        date: date,
                        dateStr: moment(date).format('YYYY-MM-DD'),
                        day: dayStr(date.getDate()),
                        week: week,
                        dayOfWeekStr: dayOfWeekStr(date),
                        monthStr: monthStr(date),
                        summary: {
                            count: 0,
                            draftCount: 0,
                            unassigned: 0,
                            unavailabilities: 0,
                            state: ''
                        }
                    })
                }.bind(this))
                if (setIt) this.monthdays = monthdays;

                return monthdays;
            },
            onScroll(){
                // clearTimeout(this.bodyScrollTo);
                // this.bodyScrollTo = setTimeout(function(){
                    var loadMoreEl = this.$refs["loadMoreProjects"];
                    // var loadMoreParent = document.body;
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = (window.innerHeight || document.documentElement.clientHeight)
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreUserProfiles()
                        }
                    }
                // }.bind(this), 300)
            },
            getMoreUserProfiles(){
                this.$nextTick(function(){
                    if (this.loading || !this.paginatedResources.paginatorInfo.hasMorePages) return;
                    
                    this.$apollo.queries.paginatedResources.fetchMore({
                        variables: {
                            page: this.paginatedResources.paginatorInfo.currentPage+1,
                            // page: this.currentPage,
                            first: this.pageSize,
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            let data = {}
                            data.paginatedResources ={
                                __typename: fetchMoreResult.paginatedResources.__typename,
                                // data: [...previousResult.paginatedResources.data, ...fetchMoreResult.paginatedResources.data],
                                data: [...this.paginatedResources.data, ...fetchMoreResult.paginatedResources.data],
                                paginatorInfo: fetchMoreResult.paginatedResources.paginatorInfo
                            }
                            return data
                        },
                    })
                })
            }
        },
        watch: {
            daterange: function(){
                // this.resources=null;
                this.projectDetailsVisible=0
                this.showProjectDetails=0
                this.currentPage=1
                this.monthdays=this.setMonthDays();
                this.showProjects=false
                setTimeout(function(){
                    if(!this.$apollo.queries.paginatedResources.loading) this.showProjects=true
                }.bind(this), 550)
            },
            loading: function(){
                if(this.loading) return
                this.$nextTick(function(){
                    this.onScroll()
                })
            },
        },
        apollo: {
            paginatedResources: {
                query: PAGINATEDRESOURCES,
                fetchPolicy: 'network-only',
                // fetchPolicy: 'cache-and-network',
                debounce: 500,
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    let variables={};
                    if(this.daterange) variables.dateRange=this.daterange.str
                    if(this.daterange) variables.shiftsDateRange=this.daterange.str
                    if (this.moreFilters) {
                        variables.moreFilters = this.moreFilters
                        if (this.daterange) variables.moreFilters.dateRange = this.daterange.str
                        if (this.moreFilters.projects?.length > 0) variables.projects = this.moreFilters.projects
                    }
                    if (this.orderBy) {
                        variables.orderBy = this.orderBy
                    }
                    if (this.orderSort) {
                        variables.orderSort = this.orderSort
                    }

                    variables.first=this.pageSize;
                    variables.page = 1;
                    // variables.limitStaff = true;
                    
                    if(variables){
                        return {...variables}
                    }
                },
                update(data) {
                    this.showProjects=true
                    return data.paginatedResources;
                },
            }
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/dashboard/MonthView.scss";

    .-summary-cell {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &>span {
            width: 100%;
            height: 100%;
            display: flex;

            &>span {
                flex-grow: 1;
                align-content: center;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                // color: white;
                font-size: 0.9rem;
                // padding-bottom: 6px;
            }
        }
    
    }
    
    .c-monthly-cell .c-project .-userprofile-info__toggle {
        color: black !important;
    }

</style>
